(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if (this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kik-features"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kik-features')) {
    class KikFeatures extends HTMLElement {
      constructor() {
        super();

        this.switchMethod = this.dataset.switchMethod || 'click';
        this.autoIntervalMs = parseInt(this.dataset.autoInterval) || 5000;
        this.totalTabs = parseInt(this.dataset.totalTabs) || 0;
        this.currentTab = 0;
        this.autoInterval = null;

        // Desktop elements
        this.tabItems = this.querySelectorAll('.kik-features-section__tab-item');
        this.imagePanels = this.querySelectorAll('.kik-features-section__panel');

        // Mobile elements
        this.mobileTabs = this.querySelectorAll('.kik-features-section__mobile-tab');
      }

      connectedCallback() {
        this.setupDesktopTabs();
        this.setupMobileTabs();

        // Auto-rotation (desktop only)
        if (this.switchMethod === 'auto' && window.innerWidth >= 768) {
          this.startAutoRotation();
        }

        // Handle resize
        this.handleResize = this.handleResize.bind(this);
        window.addEventListener('resize', this.handleResize);
      }

      disconnectedCallback() {
        this.stopAutoRotation();
        window.removeEventListener('resize', this.handleResize);
      }

      setupDesktopTabs() {
        this.tabItems.forEach((tab, index) => {
          tab.addEventListener('click', () => {
            this.switchTab(index);
            this.stopAutoRotation();
          });

          if (this.switchMethod === 'hover') {
            tab.addEventListener('mouseenter', () => {
              this.switchTab(index);
            });
          }

          tab.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              this.switchTab(index);
              this.stopAutoRotation();
            } else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
              e.preventDefault();
              this.nextTab();
              this.stopAutoRotation();
            } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
              e.preventDefault();
              this.prevTab();
              this.stopAutoRotation();
            } else if (e.key === 'Home') {
              e.preventDefault();
              this.switchTab(0);
              this.stopAutoRotation();
            } else if (e.key === 'End') {
              e.preventDefault();
              this.switchTab(this.totalTabs - 1);
              this.stopAutoRotation();
            }
          });
        });
      }

      setupMobileTabs() {
        this.mobileTabs.forEach((tab, index) => {
          tab.addEventListener('click', () => {
            this.toggleMobileTab(index);
          });
        });
      }

      switchTab(index) {
        if (index === this.currentTab) return;

        this.tabItems.forEach((tab, i) => {
          const isActive = i === index;
          tab.classList.toggle('kik-features-section__tab-item--active', isActive);
          tab.setAttribute('aria-selected', isActive);
          tab.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        this.imagePanels.forEach((panel, i) => {
          if (i === index) {
            panel.classList.remove('is-hidden');
            const video = panel.querySelector('video');
            if (video) video.play().catch(() => {});
          } else {
            panel.classList.add('is-hidden');
            const video = panel.querySelector('video');
            if (video) video.pause();
          }
        });

        this.currentTab = index;

        if (this.tabItems[index]) {
          this.tabItems[index].focus();
        }
      }

      toggleMobileTab(index) {
        this.mobileTabs.forEach((tab, i) => {
          const isActive = i === index;
          tab.classList.toggle('kik-features-section__mobile-tab--active', isActive);

          if (isActive) {
            const video = tab.querySelector('video');
            if (video) video.play().catch(() => {});
          } else {
            const video = tab.querySelector('video');
            if (video) video.pause();
          }
        });
      }

      nextTab() {
        const nextIndex = (this.currentTab + 1) % this.totalTabs;
        this.switchTab(nextIndex);
      }

      prevTab() {
        const prevIndex = (this.currentTab - 1 + this.totalTabs) % this.totalTabs;
        this.switchTab(prevIndex);
      }

      startAutoRotation() {
        this.stopAutoRotation();
        this.autoInterval = setInterval(() => {
          this.nextTab();
        }, this.autoIntervalMs);
      }

      stopAutoRotation() {
        if (this.autoInterval) {
          clearInterval(this.autoInterval);
          this.autoInterval = null;
        }
      }

      handleResize() {
        if (this.switchMethod === 'auto') {
          if (window.innerWidth >= 768) {
            this.startAutoRotation();
          } else {
            this.stopAutoRotation();
          }
        }
      }
    }

    customElements.define('kik-features', KikFeatures);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kik-our-vs-others"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kik-our-vs-others')) {
    class KikOurVsOthers extends HTMLElement {
      constructor() {
        super();
        this.items = this.querySelectorAll('.kik-vsothers-item');
        this.handle = this.querySelector('[data-handle]');
        this.track = this.querySelector('[data-track]');
        this.tooltip = this.querySelector('[data-tooltip]');

        this.state = {
          currentIndex: 0,
          position: 0, // Start at 0% (left)
          isDragging: false,
          hasInteracted: false,
          startX: 0,
          startPos: 0,
        };

        // Bind methods
        this.onDragStart = this.onDragStart.bind(this);
        this.onDragMove = this.onDragMove.bind(this);
        this.onDragEnd = this.onDragEnd.bind(this);
        this.onTrackClick = this.onTrackClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.updateSliderPosition = this.updateSliderPosition.bind(this);
      }

      connectedCallback() {
        this.initEventListeners();
        this.initIntersectionObserver();

        // Initial update to 0% (handle starts at left, animates right to center)
        this.updateSliderPosition(0);
      }

      initEventListeners() {
        if (!this.handle || !this.track) return;

        // Handle events (Mouse & Touch)
        this.handle.addEventListener('mousedown', this.onDragStart);
        this.handle.addEventListener('touchstart', this.onDragStart, { passive: false });

        // Track click
        this.track.addEventListener('click', this.onTrackClick);

        // Keyboard
        this.handle.addEventListener('keydown', this.onKeyDown);

        // Thumbnails
        const thumbs = this.querySelectorAll('[data-thumb-index]');
        thumbs.forEach((thumb) => {
          thumb.addEventListener('click', (e) => {
            const index = parseInt(e.currentTarget.dataset.thumbIndex);
            this.setActiveItem(index);
          });
        });
      }

      initIntersectionObserver() {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && !this.state.hasInteracted) {
                // Show tooltip
                if (this.tooltip) this.tooltip.classList.remove('kik-hidden');

                // Animate from 0% to 50% (center)
                this.animateSliderTo(50);

                observer.disconnect();
              }
            });
          },
          { threshold: 0.5 }
        );

        observer.observe(this);
      }

      markInteracted() {
        if (!this.state.hasInteracted) {
          this.state.hasInteracted = true;
          if (this.tooltip) this.tooltip.classList.add('kik-hidden');
        }
      }

      onDragStart(e) {
        this.markInteracted();
        this.state.isDragging = true;
        this.state.startX = e.type === 'mousedown' ? e.clientX : e.touches[0].clientX;
        this.state.startPos = this.state.position;

        this.handle.classList.add('kik-dragging');

        document.addEventListener('mousemove', this.onDragMove);
        document.addEventListener('touchmove', this.onDragMove, { passive: false });
        document.addEventListener('mouseup', this.onDragEnd);
        document.addEventListener('touchend', this.onDragEnd);
      }

      onDragMove(e) {
        if (!this.state.isDragging) return;

        // Prevent scrolling on mobile while dragging
        if (e.type === 'touchmove') e.preventDefault();

        const clientX = e.type === 'mousemove' ? e.clientX : e.touches[0].clientX;
        const trackRect = this.track.getBoundingClientRect();
        const deltaX = clientX - this.state.startX;

        // Calculate percentage change
        const deltaPercent = (deltaX / trackRect.width) * 100;

        this.updateSliderPosition(this.state.startPos + deltaPercent);
      }

      onDragEnd() {
        this.state.isDragging = false;
        this.handle.classList.remove('kik-dragging');

        document.removeEventListener('mousemove', this.onDragMove);
        document.removeEventListener('touchmove', this.onDragMove);
        document.removeEventListener('mouseup', this.onDragEnd);
        document.removeEventListener('touchend', this.onDragEnd);
      }

      onTrackClick(e) {
        if (e.target === this.handle || this.handle.contains(e.target)) return;

        this.markInteracted();
        const trackRect = this.track.getBoundingClientRect();
        const clickX = e.clientX - trackRect.left;
        const percent = (clickX / trackRect.width) * 100;

        this.updateSliderPosition(percent);
      }

      onKeyDown(e) {
        if (e.key === 'ArrowLeft') {
          this.markInteracted();
          this.updateSliderPosition(this.state.position - 5);
          e.preventDefault();
        } else if (e.key === 'ArrowRight') {
          this.markInteracted();
          this.updateSliderPosition(this.state.position + 5);
          e.preventDefault();
        }
      }

      updateSliderPosition(percent) {
        // Clamp between 0 and 100
        percent = Math.max(0, Math.min(100, percent));
        this.state.position = percent;

        // Update Handle position (centered on the percentage point)
        if (this.handle) {
          this.handle.style.left = `${percent}%`;
          this.handle.setAttribute('aria-valuenow', Math.round(percent));
        }

        // Update Track Gradient (gray = Others on left, brand = Ours on right)
        if (this.track) {
          this.track.style.background = `linear-gradient(to right, #999999 0%, #999999 ${percent}%, #9C5455 ${percent}%, #9C5455 100%)`;
        }

        // Update Clipper and Divider for Active Item
        const activeItem = this.items[this.state.currentIndex];
        if (activeItem) {
          const clipper = activeItem.querySelector('[data-clipper]');
          const divider = activeItem.querySelector('[data-divider]');

          if (clipper) {
            // Clip left by percent%: at 50% handle, shows right 50% of "our" image
            clipper.style.clipPath = `inset(0 0 0 ${percent}%)`;
          }

          if (divider) {
            // Move divider line to match slider position
            divider.style.left = `${percent}%`;
          }
        }

        // Update tooltip position
        if (this.tooltip) {
          this.tooltip.style.left = `${percent}%`;
        }
      }

      animateSliderTo(targetPercent) {
        const start = this.state.position;
        const duration = 800;
        const startTime = performance.now();

        const animate = (currentTime) => {
          if (this.state.hasInteracted) return;

          const elapsed = currentTime - startTime;
          const progress = Math.min(elapsed / duration, 1);

          // Easing (ease-out-cubic)
          const ease = 1 - Math.pow(1 - progress, 3);

          const newPos = start + (targetPercent - start) * ease;
          this.updateSliderPosition(newPos);

          if (progress < 1) {
            requestAnimationFrame(animate);
          }
        };

        requestAnimationFrame(animate);
      }

      setActiveItem(index) {
        if (index === this.state.currentIndex) return;

        // Switch Items
        this.items.forEach((item, i) => {
          if (i === index) {
            item.classList.remove('kik-hidden');
          } else {
            item.classList.add('kik-hidden');
          }
        });

        // Update Thumbs
        const thumbs = this.querySelectorAll('[data-thumb-index]');
        thumbs.forEach((thumb, i) => {
          if (i === index) {
            thumb.classList.add('kik-vsothers-thumb--active');
            thumb.setAttribute('aria-selected', 'true');
          } else {
            thumb.classList.remove('kik-vsothers-thumb--active');
            thumb.setAttribute('aria-selected', 'false');
          }
        });

        this.state.currentIndex = index;

        // Sync slider state to current item
        this.updateSliderPosition(this.state.position);

        // Update tooltip text
        const activeItem = this.items[index];
        if (this.tooltip && activeItem) {
          const text = activeItem.dataset.tooltipText;
          const inner = this.tooltip.querySelector('.kik-vsothers-tooltip-text');
          if (inner && text) {
            inner.textContent = text;
          }
        }
      }
    }

    customElements.define('kik-our-vs-others', KikOurVsOthers);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kik-slideshow-j"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kik-slideshow')) {
  /**
   * KIK Slideshow Web Component
   * Powered by Embla Carousel
   * Desktop: Peek carousel with thumbnail cards
   * Mobile: Full-width with title/desc below + segmented progress
   */
  class KikSlideshow extends HTMLElement {
    constructor() {
      super();
      this.currentSlide = 0;
      this.emblaApi = null;
      this.autoplayPlugin = null;
      this.isDesktop = window.innerWidth >= 768;
    }

    connectedCallback() {
      // Get elements
      this.viewport = this.querySelector('[data-embla-viewport]');
      this.container = this.querySelector('[data-embla-container]');
      this.slides = this.querySelectorAll('.kik-embla__slide');
      this.prevBtn = this.querySelector('[data-embla-prev]');
      this.nextBtn = this.querySelector('[data-embla-next]');
      this.thumbnails = this.querySelectorAll('[data-thumbnail]');
      this.progressBar = this.querySelector('[data-progress-bar]');
      this.desktopProgress = this.querySelectorAll('[data-desktop-segment]');
      this.mobileContent = this.querySelectorAll('[data-mobile-slide]');
      this.mobileProgress = this.querySelectorAll('[data-segment]');
      this.carouselDots = this.querySelectorAll('[data-dot]');
      this.srStatus = this.querySelector('[data-sr-status]');

      // Get settings
      this.totalSlides = parseInt(this.dataset.totalSlides, 10);
      this.autoplay = this.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10);
      this.infiniteLoop = this.dataset.infiniteLoop === 'true';
      this.enableDrag = this.dataset.enableDrag === 'true';
      this.transitionEffect = this.dataset.transitionEffect || 'slide';
      this.enablePeek = this.dataset.enablePeek === 'true';
      this.progressStyleDesktop = this.dataset.progressStyleDesktop || 'thin';
      this.showThumbnails = this.dataset.showThumbnails === 'true';
      this.showCarouselDots = this.dataset.showCarouselDots === 'true';

      if (this.totalSlides > 0) {
        this.initEmbla();
        this.setupEventListeners();

        // Update on resize
        window.addEventListener('resize', () => {
          this.isDesktop = window.innerWidth >= 768;
        });
      }
    }

    disconnectedCallback() {
      if (this.emblaApi) {
        this.emblaApi.destroy();
      }
    }

    /**
     * Initialize Embla Carousel
     */
    initEmbla() {
      const options = {
        loop: this.infiniteLoop,
        align: 'center',
        containScroll: false,
        dragFree: false,
        draggable: this.enableDrag,
        skipSnaps: false
      };

      const plugins = [];

      // Autoplay plugin
      if (this.autoplay && this.totalSlides > 1) {
        this.autoplayPlugin = window.EmblaCarouselAutoplay({
          delay: this.autoplaySpeed,
          stopOnInteraction: true,
          stopOnMouseEnter: true,
          playOnInit: true
        });
        plugins.push(this.autoplayPlugin);
      }

      // ClassNames plugin for styling active slides
      plugins.push(window.EmblaCarouselClassNames({
        snapped: 'is-snapped',
        inView: 'is-in-view'
      }));

      // Initialize Embla
      this.emblaApi = window.EmblaCarousel(this.viewport, options, plugins);

      // Listen to Embla events
      this.emblaApi.on('select', this.onSelect.bind(this));
      this.emblaApi.on('init', this.onInit.bind(this));
    }

    /**
     * Setup event listeners
     */
    setupEventListeners() {
      // Navigation arrows
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.emblaApi.scrollPrev());
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.emblaApi.scrollNext());
      }

      // Thumbnail navigation (desktop)
      this.thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', (e) => {
          const index = parseInt(e.currentTarget.dataset.thumbnail, 10);
          this.emblaApi.scrollTo(index);
        });
      });

      // Carousel dots navigation
      this.carouselDots.forEach((dot) => {
        dot.addEventListener('click', (e) => {
          const index = parseInt(e.currentTarget.dataset.dot, 10);
          this.emblaApi.scrollTo(index);
        });
      });

      // Keyboard navigation
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.emblaApi.scrollPrev();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.emblaApi.scrollNext();
        }
      });
    }

    /**
     * Called when Embla initializes
     */
    onInit() {
      this.updateUI();
    }

    /**
     * Called when slide changes
     */
    onSelect() {
      this.currentSlide = this.emblaApi.selectedScrollSnap();
      this.updateUI();
    }

    /**
     * Update all UI elements
     */
    updateUI() {
      this.updateThumbnails();
      this.updateProgressBar();
      this.updateDesktopProgress();
      this.updateMobileContent();
      this.updateMobileProgress();
      this.updateCarouselDots();
      this.updateScreenReader();
    }

    /**
     * Update thumbnail active state (desktop only)
     */
    updateThumbnails() {
      this.thumbnails.forEach((thumbnail, index) => {
        if (index === this.currentSlide) {
          thumbnail.classList.add('is-active');
        } else {
          thumbnail.classList.remove('is-active');
        }
      });
    }

    /**
     * Update desktop progress bar (thin line style)
     */
    updateProgressBar() {
      if (!this.progressBar) return;

      const progress = ((this.currentSlide + 1) / this.totalSlides) * 100;
      this.progressBar.style.width = `${progress}%`;
    }

    /**
     * Update desktop segmented progress bar
     */
    updateDesktopProgress() {
      this.desktopProgress.forEach((segment, index) => {
        if (index === this.currentSlide) {
          segment.classList.add('is-active');
        } else {
          segment.classList.remove('is-active');
        }
      });
    }

    /**
     * Update mobile content (title + description)
     */
    updateMobileContent() {
      this.mobileContent.forEach((content, index) => {
        if (index === this.currentSlide) {
          content.classList.remove('kik-hidden');
        } else {
          content.classList.add('kik-hidden');
        }
      });
    }

    /**
     * Update mobile segmented progress bar
     */
    updateMobileProgress() {
      this.mobileProgress.forEach((segment, index) => {
        if (index === this.currentSlide) {
          segment.classList.add('is-active');
        } else {
          segment.classList.remove('is-active');
        }
      });
    }

    /**
     * Update carousel dots
     */
    updateCarouselDots() {
      this.carouselDots.forEach((dot, index) => {
        if (index === this.currentSlide) {
          dot.classList.add('is-active');
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.classList.remove('is-active');
          dot.setAttribute('aria-current', 'false');
        }
      });
    }

    /**
     * Update screen reader announcement
     */
    updateScreenReader() {
      if (!this.srStatus) return;

      const currentNum = this.currentSlide + 1;
      this.srStatus.textContent = `Slide ${currentNum} of ${this.totalSlides}`;
    }
  }

  customElements.define('kik-slideshow', KikSlideshow);
}

  } catch(e) { console.error(e); }
})();
})();
